<template>
  <v-autocomplete
    :items="filteredAddresses"
    :label="label"
    v-model="selected"
    :multiple="multi"
    item-text="SiteInsitutionName"
    return-object
  >
    <template slot="selection" slot-scope="data">
      {{ data.item.SiteInsitutionName }}
    </template>
    <template slot="item" slot-scope="props">
      <v-list-tile-content>
        <v-list-tile-title>
          {{ props.item.SiteInsitutionName }}
        </v-list-tile-title>
        <v-list-tile-sub-title>
          {{ props.item.Address1 }}, {{ props.item.City }},
          {{ props.item.State }} {{ props.item.Zip }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
const moduleNamespace = 'siteAddress'
export default {
  name: 'v-siteAddress',
  props: {
    label: '',
    value: null,
    multi: false,
  },
  data() {
    return {
      items: [],
      selected: this.value,
    }
  },
  created() {
    this.getSiteAddress()
  },
  methods: {
    ...mapActions(moduleNamespace, ['getSiteAddress']),
  },
  computed: {
    ...mapGetters(moduleNamespace, ['siteAddress']),
    filteredAddresses() {
      let list = this.siteAddress.filter((x) => !x.NotInUse)
      let selectedItem = this.siteAddress.find((x) => x.ID == this.value.ID)
      if (!list.find((i) => i.ID == this.value.ID) && selectedItem) {
        list.push(selectedItem)
      }
      return list
    },
  },
  watch: {
    selected(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.selected = val
    },
  },
}
</script>
<style></style>
